import React from 'react';
import { Button, Card, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { format } from 'date-fns';

const formatCurrency = (value) =>
  new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 }).format(
    Number(value || 0),
  );

const formatDateTime = (value, pattern = 'dd/MM HH:mm') => {
  if (!value) return '-';
  try { return format(new Date(value), pattern); } catch { return value; }
};

const differenceClass = (value) => {
  if (value > 0) return 'text-success';
  if (value < 0) return 'text-danger';
  return 'text-muted';
};

const CashierReportModal = ({ show, shift, report, loading, onHide }) => (
  <Modal show={show} onHide={onHide} size="lg">
    <Modal.Header closeButton>
      <Modal.Title>Báo cáo ca thu ngân</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" size="sm" /> Đang tải báo cáo...
        </div>
      ) : !report ? (
        <div className="text-muted">Chưa có dữ liệu báo cáo</div>
      ) : (
        <>
          <div className="mb-3">
            <div className="fw-semibold">{shift?.employeeName}</div>
            <small className="text-muted">
              {report.shift_info?.branch} · {formatDateTime(report.shift_info?.start_time)} –{' '}
              {formatDateTime(report.shift_info?.end_time)}
            </small>
          </div>

          <Row className="g-3 mb-3">
            <Col md={4}>
              <Card>
                <Card.Body>
                  <small className="text-muted">Tiền đầu ca</small>
                  <h5 className="mb-0">{formatCurrency(report.cash_summary?.opening_cash)}</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <Card.Body>
                  <small className="text-muted">Doanh thu tiền mặt</small>
                  <h5 className="mb-0">{formatCurrency(report.cash_summary?.cash_revenue)}</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <Card.Body>
                  <small className="text-muted">Tổng phiếu chi</small>
                  <h5 className="mb-0">{formatCurrency(report.cash_summary?.cash_expenses)}</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="d-flex gap-4 mb-4 p-3 bg-light rounded">
            <div>
              <div className="text-muted small">Dự kiến cuối ca</div>
              <h5 className="mb-0">{formatCurrency(report.cash_summary?.expected_closing_cash)}</h5>
            </div>
            <div>
              <div className="text-muted small">Thực tế</div>
              <h5 className="mb-0">{formatCurrency(report.cash_summary?.actual_closing_cash)}</h5>
            </div>
            <div>
              <div className="text-muted small">Chênh lệch</div>
              <h5 className={`mb-0 ${differenceClass(report.cash_summary?.difference)}`}>
                {formatCurrency(report.cash_summary?.difference)}
              </h5>
            </div>
          </div>

          {report.cash_vouchers?.length > 0 && (
            <div>
              <h6 className="mb-2">Phiếu chi liên quan ({report.cash_vouchers.length})</h6>
              <ul className="list-unstyled mb-0">
                {report.cash_vouchers.map((v) => (
                  <li key={v.voucher_number || v.id} className="d-flex justify-content-between small py-1 border-bottom">
                    <span>
                      {v.voucher_number} · {v.category} · {v.recipient_name || '-'}
                    </span>
                    <span className="fw-semibold">{formatCurrency(v.amount)}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>Đóng</Button>
    </Modal.Footer>
  </Modal>
);

export default CashierReportModal;
